export default [
    {
        key: 'ManualDistributeModal',
        getComponent: function () { return import('./ManualDistributeModal'); },
        width: 600,
        title: i18n.get('发票使用规范下发'),
        maskClosable: false,
        wrapClassName: 'vertical-center-modal',
    },
    {
        key: 'LogModal',
        getComponent: function () { return import('./LogModal'); },
        title: '下发记录',
        width: 800,
    },
];
